import { payScheduleId } from './pay-schedule-query.types';

type Id = payScheduleId;

export const PayScheduleAPI = {
  generatePayrun: (payScheduleId: Id) =>
    `<%userArea%>/payschedules/${payScheduleId}/generatePayrun`,
};

export const PayScheduleAPIV2 = {
  paySchedules: `/api/v2/payschedules`,
  payScheduleById: (payscheduleId: Id) => `/api/v2/payschedules/${payscheduleId}`,
  basePayMappingById: (payscheduleId: Id) =>
    `/api/v2/payschedules/${payscheduleId}/basepaymapping`,
  feesById: (payscheduleId: Id) => `/api/v2/payschedules/${payscheduleId}/fees`,
  exportList: `/api/v2/payschedules/export`,
  delete: `/api/v2/payschedules/delete`,
  updateStatus: `/api/v2/payschedules/status`,
};

export const PayScheduleStatus = {
  DEACTIVATE: 0,
  ACTIVATE: 1,
} as const;

export type PayScheduleStatusValue =
  (typeof PayScheduleStatus)[keyof typeof PayScheduleStatus];
